import type { ReactElement } from "react";
import type { KundeAkte } from "@kundeninfo/api-client";
import { relativeZeit, formatDatum } from "../format.js";
import "./Kontext.css";

export type KontextProps = {
  kunde: KundeAkte | null;
};

/** Der rechte Kontextbereich: Letzte Aktivität und die Unternehmenszuordnungen mit
 *  "Kunde seit" — unabhängig von den Tabs der Akte, immer sichtbar, solange ein Kunde
 *  ausgewählt ist. */
export function Kontext({ kunde }: KontextProps): ReactElement {
  if (kunde === null) {
    return <p className="kx__leer">Kein Kunde ausgewählt.</p>;
  }

  return (
    <div className="kx">
      <section>
        <h2 className="kx__titel">Letzte Aktivität</h2>
        <p>{relativeZeit(kunde.lastActivityAt)}</p>
      </section>
      <section>
        <h2 className="kx__titel">Unternehmenszuordnungen</h2>
        {kunde.relations.length === 0
          ? <p>Keine Zuordnung.</p>
          : (
            <ul className="kx__liste">
              {kunde.relations.map((r) => (
                <li key={r.shortCode} className="kx__eintrag">
                  <div className="kx__firma">{r.companyName}</div>
                  <div className="kx__nummer">{r.customerNumber}</div>
                  <div className="kx__seit">
                    Kunde seit {r.customerSince !== undefined && r.customerSince !== null
                      ? formatDatum(r.customerSince) : "unbekannt"}
                  </div>
                </li>
              ))}
            </ul>
          )}
      </section>
    </div>
  );
}
